export const JOBS_FETCH      = Symbol.for('job.list');
export const JOBS_ORDERBY    = Symbol.for('job.orderby');
export const JOBS_FILTER     = Symbol.for('job.filter');
export const JOBS_PAGINATION = Symbol.for('job.pagination');
export const JOB_FETCH       = Symbol.for('job.get');

export const APPLICATIONS_FETCH      = Symbol.for('application.list');
export const APPLICATIONS_ORDERBY    = Symbol.for('application.orderby');
export const APPLICATIONS_FILTER     = Symbol.for('application.filter');
export const APPLICATIONS_PAGINATION = Symbol.for('application.pagination');
export const APPLICATION_FETCH       = Symbol.for('application.get');

export const SEEKER_FETCH = Symbol.for('seeker.get');

export const APPOINTMENTS_FETCH = Symbol.for('appointments.list');
export const COMMENTS_FETCH     = Symbol.for('comments.list');
